export enum StatusTaskReport {
  PENDING_WORK = 'wait_confirm',
  REJECT = 'draft',
  PROCESSING = 'processing',
  WAITING_COMPLETE = 'wait_done',
  COMPLETE = 'done',
  CANCEL = 'cancel',
  OVERDUE = 'late',
}

export enum TypeReport {
  SUMMARY_REPORT = 1,
}

export enum PriorityTask {
  HIGHT = 1,
  MEDIUM = 2,
  LOW = 3,
}

export enum JobType {
  PROJECT = 1,
  UN_PROJECT = 0,
}

export enum Accumulated {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
}

export enum ProgressStatus {
  APPROVED = 'PHE_DUYET',
  REPORTED = 'CHO_DUYET',
  UN_APPROVED = 'TU_CHOI',
}

export enum TargetReportTime {
  TWO_MONTH = 'TWO_MONTH',
  THREE_MONTH = 'THREE_MONTH',
  SIX_MONTH = 'SIX_MONTH',
  TWELVE_MONTH = 'TWELVE_MONTH',
  CURRENT_YEAR = 'CURRENT_YEAR',
}

export enum TargetReportEvaluate {
  COMPLETE = 'COMPLETE',
  NOT_COMPLETE = 'INCOMPLETE',
  OTHER = '',
}

export enum MissionType {
  REGULAR_PERIODIC = 'REGULAR_PERIODIC',
  MONTHLY_REGISTERED = 'MONTHLY_REGISTERED',
}

export enum StatusTaskTarget {
  PROCESSING = 'processing',
  COMPLETE = 'done',
}
